<template>
  <div class="help-wrapper" :class="whiteBackground ? 'white-background' : ''">
    <div class="help-title">
      <span class="heading3">
        {{ $t('need_help_booking') }}
      </span>
      <span
        class="heading3 underline cursor-pointer"
        @click="goToDonatella()"
        style="margin-top: 4px; display: block"
        :style="whiteBackground ? 'color: var(--brand-blue)' : ''"
      >
        {{ $t('to_talk_to_donatella') }}
      </span>
    </div>
    <div class="help-icon">
      <img src="/logos/PALC_Marque_Gold.svg" />
    </div>
  </div>
</template>

<script>
export default defineComponent({
  name: 'Help',
  props: {
    whiteBackground: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const router = useRouter()

    return {
      router
    }
  }
})
</script>

<style scoped lang="scss">
.help-wrapper {
  height: 372px;
  background: var(--brand-off-black);
  color: var(--brand-white);
  padding: 140px 0px 80px 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  .help-icon {
    display: flex;
    justify-content: center;
    padding: 0px 24px;
    width: 100%;
    margin-top: 24px;
  }
  .help-title {
    text-align: center;
    padding: 0px 24px;
    width: 100%;
  }

  &.white-background {
    background: var(--brand-off-white);
    color: var(--brand-off-black);
  }
}
</style>